export default __webpack_public_path__ + "static/media/scarlatti-a-minor.cc19635e.mp3";